import { toPath } from '../../routes'
import { PageHeader } from '../Common'
import PracticeSelectView from '../Practices/PracticeSelectView'

export default function Reports() {
  return (
    <div>
      <PageHeader title="Remote Reports" />
      <PracticeSelectView routeMethod={toPath.practices.reports} />
    </div>
  )
}
